// src/utils/jwt.js
export function unwrapJWT(base64Token) {
  try {
    return atob(base64Token); // token ถูกหุ้ม base64 ธรรมดา → ได้ "header.payload.signature"
  } catch {
    return null;
  }
}

function base64UrlToBase64(s) {
  return s.replace(/-/g, '+').replace(/_/g, '/').padEnd(Math.ceil(s.length / 4) * 4, '=');
}

export function decodeJWTPayload(base64Token) {
  const raw = unwrapJWT(base64Token);
  if (!raw) return null;
  const parts = raw.split('.');
  if (parts.length < 2) return null;
  try {
    const payloadJson = atob(base64UrlToBase64(parts[1]));
    return JSON.parse(payloadJson);
  } catch {
    return null;
  }
}

export function getExpMs(base64Token) {
  const p = decodeJWTPayload(base64Token);
  return p?.exp ? p.exp * 1000 : null;
}
export function getIatMs(base64Token) {
  const p = decodeJWTPayload(base64Token);
  return p?.iat ? p.iat * 1000 : null;
}

export function isExpired(base64Token) {
  const expMs = getExpMs(base64Token);
  if (!expMs) return true;
  return Date.now() >= expMs;
}

export function msLeft(base64Token) {
  const expMs = getExpMs(base64Token);
  return expMs ? Math.max(0, expMs - Date.now()) : 0;
}

export function fmt(dtMs) {
  if (!dtMs) return '-';
  return new Date(dtMs).toLocaleString('th-TH', {
    timeZone: 'Asia/Bangkok',
    hour12: false
  });
}

// ============== logger กลาง ==============
export function logToken(base64Token, from = 'unknown') {
  const iat = getIatMs(base64Token);
  const exp = getExpMs(base64Token);
  const left = msLeft(base64Token);
  const expired = isExpired(base64Token);
  // ใช้ groupCollapsed ให้ log ดูง่าย
  console.groupCollapsed(`[TOKEN] ${from}`);
  console.log('issued at (iat):', iat, fmt(iat));
  console.log('expires  (exp):', exp, fmt(exp));
  console.log('now:', Date.now(), fmt(Date.now()));
  console.log('left(ms):', left, 'left(s):', (left/1000).toFixed(1), 'expired?', expired);
  console.groupEnd();
  return { iat, exp, left, expired };
}
